module.exports = __webpack_public_path__ + "img/pageleft.dd6e34f4.svg";